import { Injectable } from "@angular/core";
import { HttpService } from "./utils/http.service";
import { IOrderQCModel, IOrderQCListModel, IOrderQCQuestionTypeModel, IDocumentModel } from '@models';

@Injectable()
export class OrderQCService {
	private static _orderQCQuestionTypes: IOrderQCQuestionTypeModel[];

	constructor(private httpService: HttpService) { }

	async getOrderQC(orderId: number): Promise<IOrderQCModel> {
		return Promise.resolve(await this.httpService.get("/orderQC/getOrderQC", { orderId: orderId }));
	}

	async getOrderQCList(factory: string): Promise<IOrderQCListModel[]> {
		return Promise.resolve(await this.httpService.get("/orderQC/getOrderQCList", { factory: factory }));
	}

	async loadOrderQCQuestionTypes(): Promise<IOrderQCQuestionTypeModel[]> {
		OrderQCService._orderQCQuestionTypes = await this.httpService.get("/orderQC/getOrderQCQuestionTypes");

		return OrderQCService._orderQCQuestionTypes;
	}

	get orderQCQuestionTypes(): IOrderQCQuestionTypeModel[] {
		return OrderQCService._orderQCQuestionTypes;
	}

	async completeQC(orderQCModel: IOrderQCModel): Promise<IOrderQCModel> {
		return Promise.resolve(await this.httpService.post("/orderQC/completeQC", orderQCModel));
	}

	async uploadQCPhoto(orderId: number, file: File): Promise<IDocumentModel> {
		try {
			let formData: FormData = new FormData();
			formData.append('file', file);

			const returnFileModel = await this.httpService.postMultipart(`/orderQC/uploadQCPhoto?orderId=${orderId}`,formData);
			return Promise.resolve(returnFileModel);
		}
		catch (error) {
			console.error(error);
			return Promise.reject(error);
		}
	}
}
